/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface AgencyGroupFormData
 */
export interface AgencyGroupFormData {
    /**
     * 
     * @type {string}
     * @memberof AgencyGroupFormData
     */
    id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyGroupFormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {object}
     * @memberof AgencyGroupFormData
     */
    effectiveFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof AgencyGroupFormData
     */
    effectiveTo?: object | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyGroupFormData
     */
    label?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyGroupFormData
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyGroupFormData
     */
    disabled?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof AgencyGroupFormData
     */
    brandAndMarket?: BrandAndMarketListItem;
}

export function AgencyGroupFormDataFromJSON(json: any): AgencyGroupFormData {
    return AgencyGroupFormDataFromJSONTyped(json, false);
}

export function AgencyGroupFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyGroupFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'effectiveFrom': !exists(json, 'effectiveFrom') ? undefined : json['effectiveFrom'],
        'effectiveTo': !exists(json, 'effectiveTo') ? undefined : json['effectiveTo'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
    };
}

export function AgencyGroupFormDataToJSON(value?: AgencyGroupFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'allowEdit': value.allowEdit,
        'effectiveFrom': value.effectiveFrom,
        'effectiveTo': value.effectiveTo,
        'label': value.label,
        'description': value.description,
        'disabled': value.disabled,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
    };
}


